export const searchTypes = ['All', 'Programmes', 'Articles', 'Employees', 'Events'] as const;

export type SearchTypes = (typeof searchTypes)[number];

/** Parse the `type` search parameter to a search type, falling back to 'All' when absent or unknown. */
export const toSearchType = (value: string | null): SearchTypes =>
    searchTypes.includes(value as SearchTypes) ? (value as SearchTypes) : 'All';

export type SearchFacets = {
    totalCount: number;
    programmes: number;
    articles: number;
    employees: number;
    events: number;
};

export type FrontpageResponse = {
    facets: SearchFacets;
    programmes: SearchResult[];
    articles: SearchResult[];
    employees: SearchResult[];
    events: SearchResult[];
};

export type SearchResponse = {
    query: string;
    results: SearchResult[];
    count: number;
};

export type SearchResult = {
    id: string;
    contentId: string;
    title: string;
    type: 'Programmes' | 'Articles' | 'Employees' | 'Events';
    url: string;
    language: string;
    score: number;
    programmeData: ProgrammeData | null;
    articleData: ArticleData | null;
    employeeData: EmployeeData | null;
    eventData: EventData | null;
};

export type ProgrammeData = {
    levels: string[];
    loads: ('FullTime' | 'PartTime')[];
    programmeLanguage: 'English' | 'Norwegian';
    academicFields: string[];
    programmeId: number;
    campuses: string[];
    credits: number;
    terms: string[];
};

export type ArticleData = {
    type: 'News' | 'BiBusinessReview' | 'Other';
    date: string | null;
    image: string | null;
    summary: string;
};

export type EmployeeData = {
    campus: string;
    image: string | null;
    role: string;
    department: string | null;
    phone: string | null;
    email: string | null;
};

export type EventData = {
    campuses: string[];
    types: string[];
    image: string | null;
    location: string;
    from: string;
    to: string;
};
